var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"energy-rating-indicator"},[_c('div',{staticClass:"arrow",style:({ borderRightColor: _vm.color })}),_c('span',{style:({ backgroundColor: _vm.color, color: _vm.textColor })},[_vm._v(_vm._s(_vm.rating)+" "+_vm._s(_vm.status))])])
}
var staticRenderFns = []

export { render, staticRenderFns }